import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["color", "color2"];
import React from 'react';
function EmailSend(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#A9B1B9' : _ref$color,
    _ref$color2 = _ref.color2,
    color2 = _ref$color2 === void 0 ? '#FF8C00' : _ref$color2,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12.0224 6H4C2.9 6 2.01 6.9 2.01 8L2 20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V8.66308C21.1996 9.79974 19.9794 10.6195 18.5648 10.897L12 15L4 10V8L12 13L15.6885 10.6947C13.6915 9.99838 12.2192 8.18311 12.0224 6Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.75 2V3.3125H19.8125L15 8.125L15.875 9L20.6875 4.1875V7.25H22V2H16.75Z",
    fill: color2
  }));
}
export default EmailSend;